import './instrument';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { initGtm } from './lib/analytics';
import { initI18n } from './i18n';

if (import.meta.env.PROD) {
  initGtm();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
  {
    onUncaughtError: Sentry.reactErrorHandler(),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  },
);

void initI18n().then(() => {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
